__turbopack_context__.v({
  "a": "rNFNDG_a",
  "button": "rNFNDG_button",
  "card": "rNFNDG_card",
  "card-copy-content": "rNFNDG_card-copy-content",
  "card-eyebrow": "rNFNDG_card-eyebrow",
  "card-image": "rNFNDG_card-image",
  "card-subtitle": "rNFNDG_card-subtitle",
  "card-title": "rNFNDG_card-title",
  "icon": "rNFNDG_icon",
  "icon-container": "rNFNDG_icon-container",
  "second-button-container": "rNFNDG_second-button-container",
});
